import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

export interface GlobalSettings {
  _id: string;
  key: string;
  value: string;
  parameters?: Record<string, any>;
}

@Injectable()
export class GlobalSettingsService {
  globalSettingsUrl = "global-settings";

  constructor(private httpClient: HttpClient) {}

  get(key: string): Promise<GlobalSettings> {
    let url = `${this.globalSettingsUrl}?key=${key}`;
    return this.httpClient
      .get(url)
      .toPromise()
      .then((response) => response as GlobalSettings)
      .catch(this.handleError);
  }
  handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    return Promise.reject(error.message || error);
  }
}
